import { PageEmpty } from 'components/PageEmpty';
import { useScreenSize } from 'hooks/useScreenSize';
import { useSelector } from 'hooks/useSelector';
import { ScreenSize } from 'lib/constants';
import React from 'react';
import {
  selectAseTplFieldGroup,
  selectAseTplFieldToGroupId,
  selectAseFieldInstanceIdsForGroup,
} from 'store/assessments/selectors';
import { InstanceParentParams } from 'store/assessments/types';
import { RepeatableListIntro } from './RepeatableListIntro';

type Props = { groupId: string; parent: InstanceParentParams };

export const RepeatableListEmpty: React.FC<Props> = ({ groupId, parent }) => {
  const screenSize = useScreenSize();

  const group = useSelector((state) => selectAseTplFieldGroup(state, groupId));
  const parentGroupId = useSelector((state) =>
    selectAseTplFieldToGroupId(state, parent?.fieldId || '-1'),
  );
  const parentGroup = useSelector((state) =>
    selectAseTplFieldGroup(state, parentGroupId || '-1'),
  );

  const instanceIds = useSelector((state) =>
    selectAseFieldInstanceIdsForGroup(state, {
      groupId,
      parent,
      inAssessmentOnly: true,
    }),
  );

  if (!group) {
    return null;
  }

  return (
    <PageEmpty
      text={
        instanceIds.length
          ? 'No Results Found'
          : `No ${group.name} Added${
              parentGroup
                ? ` to this ${parentGroup.calculatedInfo.singularName}`
                : ''
            }`
      }
      subtext={instanceIds.length ? 'Try a different search' : ''}
    >
      {screenSize === ScreenSize.small && (
        <RepeatableListIntro groupId={groupId} parent={parent} />
      )}
    </PageEmpty>
  );
};
